import { DestinationParamsLocalized } from './../objects/destinationParamsLocalized';
import { Column } from "../objects/column";
import { DestinationParams, TariffLetter } from "../objects/destinationParams";
import { DestinationParamsErrors } from "../objects/destinationParamsErrors";
import { DestinationParamsListConfiguration } from "../objects/destinationParamsListConfiguration";
import { DestinationParamsListCriteria } from "../objects/destinationParamsListCriteria";
import { DestinationParamsListFiltersCriteria } from "../objects/destinationParamsListFiltersCriteria";

export const CLIENT_TYPE: number[] = [1, 2, 5];

export const EMPTY_DESTINATION_PARAMS: DestinationParams = {
    id: 0,
    destination: null,
    allowed_client_type: CLIENT_TYPE,
    disallowed_flight: false,
    allowed_airline: [],
    disallowed_airline: [],
    allow_stopovers: false,
    max_stops: '',
    max_hour_spent_on_stopover: '',
    number_of_bags: [],
    change_airport: false,
    start_departure_time: '',
    end_departure_time: '',
    start_arrival_time: '',
    end_arrival_time: '',
    period: [],
    departure_dow: [0, 1, 2, 3, 4, 5, 6],
    arrival_dow: [0, 1, 2, 3, 4, 5, 6],
    ndc_TO_offer: true,
    public_ndc_offer: true,
    standard_TO_offer: true,
    public_standard_offer: true,
    allow_number_of_allotment: false,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    allowed_stopovers_airport: [],
    disallowed_stopovers_airport: [],
    allowed_departure_airport: [],
    gds_source: false,
    allow_manual_flight: false,
    hide_gds_response_on_manual_response: false,
    display_manual_response_first: false,
    assigned_trip: "CIRCUIT_PACKAGES",
    disallowed_departure_airport: [],
    allowed_arrival_airport: [],
    disallowed_arrival_airport: [],
    cabin: [],
    tariff_letters: [],
    providers: [],
    flight_duration_min: "",
    flight_duration_max: "",
    start_departure_time_inbound: "",
    end_departure_time_inbound: "",
    start_arrival_time_inbound: "",
    end_arrival_time_inbound: "",
    localization: [],
    name: ""
};

export const TARIFF_LETTERS: TariffLetter[] = ['A', 'F', 'P', 'I', 'Z', 'D', 'J', 'C', 'M', 'N', 'T', 'G', 'L', 'K', 'H', 'Q', 'V', 'X', 'B', 'S', 'Y', 'W', 'O', 'E', 'R', 'U'];


export const EMPTY_DESTINATION_PARAMS_FILTERS: DestinationParamsListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    destination: null
};

export const EMPTY_DESTINATION_PARAMS_LIST_CRITERIA: DestinationParamsListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_DESTINATION_PARAMS_FILTERS,
    search: ''
};

export const EMPTY_DESTINATION_PARAMS_ERRORS: DestinationParamsErrors = {
    disallowed_flight_error: "",
    destination_error: "",
    flight_duration_max_error: "",
    periods_error: []
};

export const DESTINATION_PARAMS_INFO_ROUTE = '/destination-params/edit/:id/info';
export const DESTINATION_PARAMS_CONTACT_ROUTE = '/destination-params/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'destination',
    field_name: 'DESTINATION',
    checked: true,
    order_by: 'destination',
    fixed_width: false,
    last_updated: false
}, {
    label: 'unauthorized-flight',
    field_name: 'UNAUTHORIZED_FLIGHT',
    checked: true,
    order_by: 'disallowed_flight',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const EMPTY_DESTINATION_PARAMS_LIST_CONFIGURATION: DestinationParamsListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const EMPTY_DESTINATION_PARAMS_LOCALIZED: DestinationParamsLocalized = {
    name: "",
    locale: 0
};

export const DESTINATION_PARAMS_MODULE = 'DESTINATION_PARAMS';
